import React from 'react'
import { colors } from '../../Colors'

export interface IProps {
    width?: number
    height?: number
    color?: string
}

const LaptopIcon = ({ width, height, color }: IProps) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width ?? 24}
            height={height ?? 24}
            viewBox='0 0 24 24'
            fill='none'
        >
            <path
                d='M2.88 3.83984C2.08608 3.83984 1.44 4.48592 1.44 5.27984V16.7998H2.4V5.27984C2.4 5.01536 2.61552 4.79984 2.88 4.79984H10.56C10.56 5.0648 10.775 5.27984 11.04 5.27984H12.96C13.225 5.27984 13.44 5.0648 13.44 4.79984H21.12C21.3845 4.79984 21.6 5.01536 21.6 5.27984V16.7998H22.56V5.27984C22.56 4.48592 21.9139 3.83984 21.12 3.83984H2.88ZM3.36 5.75984V16.7998H20.64V5.75984H3.36ZM0 17.7598V18.7198C0 19.2502 0.4296 19.6798 0.96 19.6798H23.04C23.5704 19.6798 24 19.2502 24 18.7198V17.7598H14.4C14.0928 18.067 13.6756 18.2398 13.2413 18.2398H10.7587C10.3239 18.2398 9.9072 18.067 9.6 17.7598H0Z'
                fill={color ?? colors.grey[50]}
            />
        </svg>
    )
}

export default React.memo(LaptopIcon)
